var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 31,
    r: 30.5,
    fill: "#F47920",
    stroke: "#F47920"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.7075 31.7075L33.7075 40.7075C33.5199 40.8951 33.2654 41.0006 33 41.0006C32.7346 41.0006 32.4801 40.8951 32.2925 40.7075C32.1049 40.5199 31.9994 40.2654 31.9994 40C31.9994 39.7346 32.1049 39.4801 32.2925 39.2925L39.5863 32H20C19.7348 32 19.4804 31.8947 19.2929 31.7071C19.1054 31.5196 19 31.2652 19 31C19 30.7348 19.1054 30.4804 19.2929 30.2929C19.4804 30.1054 19.7348 30 20 30H39.5863L32.2925 22.7075C32.1049 22.5199 31.9994 22.2654 31.9994 22C31.9994 21.7346 32.1049 21.4801 32.2925 21.2925C32.4801 21.1049 32.7346 20.9995 33 20.9995C33.2654 20.9995 33.5199 21.1049 33.7075 21.2925L42.7075 30.2925C42.8005 30.3854 42.8742 30.4957 42.9246 30.6171C42.9749 30.7385 43.0008 30.8686 43.0008 31C43.0008 31.1314 42.9749 31.2615 42.9246 31.3829C42.8742 31.5043 42.8005 31.6146 42.7075 31.7075Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.4962bf0be650024e6037601e53c1dcfe.svg";
export { ForwardRef as ReactComponent };